import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  const submit = (event) => {
    event.preventDefault();
    let Email = document.getElementById("Email");
    if (Email === null) {
      alert("Please Enter Email");
    } else {
      alert("Thanks For Subscribe");
    }
  };
  return (
    <div>
      <section className="info_section layout_padding-top layout_padding2-bottom">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-3">
              <div className="info_links pl-lg-5">
                <h4>Menu</h4>
                <ul>
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li className="active">
                    <Link to="/about">About</Link>
                  </li>
                  <li>
                    <Link className to="/portfolio">
                      Portfolio{" "}
                    </Link>
                  </li>
                  <li>
                    <Link className to="/game">
                      Game
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="info_contact">
                <h4>Location</h4>
                <div>
                  <img src="images/location.png" alt />
                  <p>Rohtak Haryana</p>
                </div>
                <div>
                  <img src="images/telephone.png" alt />
                  <p>( +91 9306421528 )</p>
                </div>
                <div>
                  <img src="images/envelope.png" alt />
                  <p>herogaur@gmail.com</p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="info_social">
                <h4>Social Link</h4>
                <div className="social_container">
                  <div>
                    <Link
                      to="https://www.facebook.com/mr.heroajay/"
                      target="_hero"
                    >
                      <img src="images/facebook-logo.png" alt />
                    </Link>
                  </div>
                  <div>
                    <Link to="https://twitter.com/hero_gaur" target="_hero">
                      <img src="images/twitter-logo.png" alt />
                    </Link>
                  </div>
                  <div>
                    <Link
                      to="https://www.instagram.com/mr.hero_gaur/"
                      target="_hero"
                    >
                      <img src="images/instagram.png" alt />
                    </Link>
                  </div>
                  <div>
                    <Link
                      to="https://www.linkedin.com/in/herogaur/"
                      target="_hero"
                    >
                      <img src="images/linkedin-sign.png" alt />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="info_form">
                <h4>Newsletter</h4>
                <form action="#" onSubmit={submit}>
                  <input
                    type="text"
                    placeholder="Enter Your Email"
                    id="Email"
                  />
                  <button type="submit">Subscribe</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Footer;
